/***************************************************************************/
"use client";
/***************************************************************************/

import { cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "../../../utils/css";
import { ResultContext } from "./result";

const resultTitleVariants = cva("font-semibold", {
  variants: {
    variant: {
      default: "",
      success: "text-success",
      info: "text-info",
      warning: "text-warning",
      error: "text-error",
    },
    size: {
      default: "text-lg",
      sm: "",
      lg: "text-2xl",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

const ResultTitle: React.FC<React.HTMLAttributes<HTMLHeadElement>> = ({
  className,
  ...props
}) => {
  const { variant, size } = React.useContext(ResultContext);

  return (
    <div
      className={cn(resultTitleVariants({ variant, size }), className)}
      {...props}
    />
  );
};

export { ResultTitle, resultTitleVariants };
